import axios from 'axios';
import { layoutServiceFactory } from '../lib/layout-service-factory';

export function get(action, success, failed, config = {}) {
  return axios
    .get(
      `${action}`,
      {
        params: {}
        // withCredentials: true
      },
      config
    )
    .then((data) => {
      success(data);
    })
    .catch((error) => {
      failed(error);
    });
}

export function fetchApi(url, config) {
  return axios.get(`${url}`, config);
}

export function post(action, params, success, failed, config = {}) {
  return axios
    .post(`${action}`, { ...params }, config)
    .then((data) => success(data))
    .catch((error) => failed(error));
}

export async function getRouteData(route, language, navigate, currentPathName) {


  console.log('>> getRouteDate', {route, currentPathName});
  const layoutServiceInstance = layoutServiceFactory.create();
  return layoutServiceInstance
    .fetchLayoutData(route, language)
    .catch((error) => {

      console.error('  >> getRouteData got error', {error, response: error?.response, data: error?.response?.data});
      if (error.response) {
        if (error.response.status === 401) {
          navigate('/401?returnUrl=' + currentPathName);
          return null;
        }
        if (error.response.status === 404 && error.response.data) {
          return error.response.data;
        }
      }
      console.error('Route data fetch error', error, error.response);
      return null;
    });
}

export async function getRefreshToken(route, language, navigate, currentPathName) {
  try {
    const routeData = await getRouteData(route, language, navigate, currentPathName);
    // check if isAuthenticated is false show the login Button
    if (routeData !== null && routeData.sitecore && routeData.sitecore.route) {
      return routeData.sitecore.context.requestVerificationToken;
    }
    return '';
  } catch (e) {
    return '';
  }
}
